import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ai-interview-rounds-popup',
  standalone: true,
  imports: [],
  templateUrl: './ai-interview-rounds-popup.component.html',
  styleUrl: '../../globalStyle/limit-dialog-box-common.scss'
})
export class AiInterviewRoundsPopupComponent {


	constructor(
			private dialogRef: MatDialogRef<AiInterviewRoundsPopupComponent>,
			private router: Router
		) { }
	
		close() {
			this.dialogRef.close();
		}
	
		goToUpgradePlan() {
			this.router.navigate(['/student-dashboard/upgrade-plan']);
			this.close();
		}
}
